import { ReactElement } from "react";
import * as React from "react";

import useTypeOfShots from "../../../hooks/query/use-type-of-shots";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChangeTypeOfShots(TypeOfShotsId?: string): void;
};

export default function TypeOfShotSelector(props: Props): ReactElement {
  const { onChangeTypeOfShots } = props;

  const { strings } = useText(local);
  const { data, loading } = useTypeOfShots();

  if (loading || !data) {
    return <></>;
  }

  const { items: typeOfShots } = data.typeOfShots;

  return (
    <MetaSelect
      label={strings.label}
      name="value"
      getOptions={typeOfShots}
      setOption={(v): void => onChangeTypeOfShots(v["value"])}
      list={typeOfShots.map((v): { text: string; value: string } => ({
        text: v.name,
        value: v.id,
      }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Type of Shot",
  },
};
